import { Text } from '@chakra-ui/react'

export interface Testimony {
  quote: string
  author: string
}

export const TestimonialCarouselContent: React.FC<Testimony> = ({
  quote,
  author,
}) => {
  return (
    <>
      <Text fontSize="medium">“{quote}”</Text>
      <Text fontSize="medium" fontWeight="medium" mb={0}>
        - {author}
      </Text>
    </>
  )
}
